//External Libraries
import * as React from "react";
import mkTracker from "ouisys-clients/dist/pacman/record";
import { defineMessages } from "ouisys-clients/dist/clients/common-components/Intl";
import HOC, {
  initialState,
  HOCProps,
  match
} from "ouisys-clients/dist/clients/tallyman.v1-pin/HOC";
import { TranslationProvider, Translate, legals } from "./localization/index";
import { getConfig } from "ouisys-phone-input/dist/common/PhoneInput"

//Components
import Disclaimer from "ouisys-clients/dist/clients/legal-components/disclaimers";
import TopLegals from "ouisys-clients/dist/clients/legal-components/top-legals";
// import PricePoint from "ouisys-clients/dist/clients/legal-components/price-point";
import PreLander from "./components/PreLander";

import PhoneNumberEntryStep from "./components/PhoneNumberEntryStep";
import PINEntryStep from "./components/PINEntryStep";
import ThankYouStep from "./components/ThankYouStep";

//Utilities
import searchToObject from "./utils/searchToObject";

//Styling
import "./Root.scss"


//Changes logo according to service
let logoImg = require(`../src/assets/imgs/logo-${process.env.service}.png`);

const playerImg = require("../src/assets/imgs/player-3.png");

//Error messages Messages which might come from backend
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: "InvalidMSISDN",
    defaultMessage: "This mobile number is incorrect, try again",
  },
  AlreadySubscribed: {
    id: "AlreadySubscribed",
    defaultMessage: "You are already a subscriber!",
  },
  UnknownError: {
    id: "UnknownError",
    defaultMessage: "An unknown error occurred.",
  },
  InvalidPIN: {
    id: "InvalidPIN",
    defaultMessage: "Please enter the correct PIN that you received on your phone",
  },
  TooEarly: {
    id: "TooEarly",
    defaultMessage: "You must first submit a mobile number",
  },
  didnt_receive_pin_yet: {
    id: "didnt_receive_pin_yet",
    defaultMessage: "TODO: didnt_receive_pin_yet"
  }
});
const tracker = mkTracker(
  typeof window != "undefined" ? window : null,
  process.env.country,
  process.env.page
);


function Root(props: HOCProps) {

  const [locale, setLocale] = React.useState("no")
  const [msisdn, setMsisdn] = React.useState(getConfig(process.env.country).commonPrefix)
  const [skipPrelander, setSkipPrelander] = React.useState(true)
  const [modalState, setModalState] = React.useState("")

  React.useEffect(() => {
    //Show or hide pre-lander
    const search = searchToObject();
    if (search["skip-prelander"]) {
      const skip = (search["skip-prelander"] === "true") ? true : false
      if (skip) {
        setSkipPrelander(true)
      }
    }

    if(typeof window != "undefined"){
      window.addEventListener("load",function(){
        var trigger = document.getElementById("trigger");
        trigger.addEventListener("click", function(){
          setModalState("active");
        })
      })
    }
  }, [])




    return (
      <TranslationProvider locale={locale}>
        <div className={"container "+locale}>
          {/* pre-lander */}
          {
            !skipPrelander &&
            <PreLander/>
          }


          {/* top-legals */}
          <TopLegals className="top-legals" locale={locale} legals={legals}  />

          <div className="creativeArea" id="trigger">

            <img src={logoImg} alt="" className="logo"/>

            {/* <h1><Translate id="mainTitle1" defaultMessage="Watch & Stream" /><br/>
            <Translate id="mainTitle2" defaultMessage="the latest movies" /></h1> */}

            <img src={playerImg} alt="" className="player"/>
            <div className="toptext"><Translate id="topvideos" defaultMessage="Top videos in real-time"/></div>
            <div className="second-line"><Translate id="enjoy" defaultMessage="Enjoy your favourite channels now!"/></div>

            <button className="btn-trigger preflowbtn" onClick={()=>tracker.customEvent("preflow", "advance", "preflow-click")}><Translate id="btn" defaultMessage="Watch Now!" /></button>
            <div className="tag"><Translate id="categories" defaultMessage="Movies • Series • Cooking • Sports • Lifestyle"/></div>

          </div>

        <div className="legalArea">

          {/* disclaimers */}
          <Disclaimer className="disclaimer" locale={locale} legals={legals}  />

        </div>

        <div className={`modal ${modalState}`}>

            <div className="modal-content">

                {match({
                msisdnEntry: rds => (
                  <PhoneNumberEntryStep
                    msisdn={msisdn}
                    rds={rds}
                    locale={locale}
                    legals={legals}
                    onEnd={(msisdn, extraParams) => {
                      setMsisdn(msisdn);
                      props.actions.submitMSISDN(
                        window,
                        null,
                        msisdn,
                        null,
                        process.env.country == 'ie' ? { "return-pin": "1" } : null
                      );
                    }}
                  />
                ),
                pinEntry: rds => (
                  <PINEntryStep
                    actualPIN={props.currentState.type == "PINEntry" ? (props.currentState.actualPIN || "") : ""}
                    onEnd={pin => props.actions.submitPIN(pin)}
                    backToStart={() => props.actions.backToStart()}
                    msisdn={msisdn}
                    rds={rds}
                  />
                ),
                completed: ({ finalUrl }) => (
                  <ThankYouStep finalUrl={finalUrl} />
                )
              })(props.currentState)}

            </div>

        </div>


        </div>
      </TranslationProvider>
    );
  }


export default HOC(tracker, Root)(initialState);